import styled, { css } from 'styled-components';
import { breakpoint, Grid } from '@grays-npm/component-library';
import { GRAYS_WEBSITE_PREFIX } from '../../../utils/constants';

const Wrapper = styled.footer`
  background-color: ${({ theme }) => theme.colors.primary.graysGray};
  margin-top: auto;
`;

const Content = styled(Grid)`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) =>
    `${theme.spacings[5].rem} ${theme.spacings[4].rem}`};
  margin: 0 auto;

  ${breakpoint('lg')`
    flex-direction: row;
    justify-content: space-between;
    padding: ${({ theme }) => theme.spacings[5].rem}
  `}

  ${breakpoint('lg')`
    padding: ${({ theme }) => theme.spacings[6].rem}
  `}
`;

const FooterText = css`
  font-size: 0.75rem;
  line-height: 14px;
  font-family: ${({ theme }) => theme.fonts.roboto};
  color: ${({ theme }) => theme.colors.primary.white};
`;

const CopyrightWrapper = styled.p`
  margin: 0;
  ${FooterText};

  ${breakpoint('xs', 'md')`
    padding-bottom: ${({ theme }) => theme.spacings[2].rem};
  `};
`;

const LinksWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
`;

const Link = styled.a`
  ${FooterText};

  &:not(:first-of-type) {
    padding-left: ${({ theme }) => theme.spacings[4].rem};
  }
`;

const Footer = () => {
  return (
    <Wrapper>
      <Content>
        <CopyrightWrapper>
          © 2025 Slattery Grays Auction Group Pty Ltd (ABN 78 692 021 122)
          - All Rights Reserved
        </CopyrightWrapper>
        <LinksWrapper>
          <Link href={`${GRAYS_WEBSITE_PREFIX}pages/privacy-policy-page`} target="_blank">
            Privacy Policy
          </Link>
          
        </LinksWrapper>
      </Content>
    </Wrapper>
  );
};

export default Footer;
